import React, { useContext, useEffect, useRef, useState } from 'react'
import axios from 'axios'
import { baseUrl, path } from '../../constants'
import { Oval } from 'react-loader-spinner'
import { appContext } from '../../Context/appProvider'
import { Controller, useForm } from 'react-hook-form';
import Select from 'react-select';
import {api} from '../../api'
import { useNavigate, useParams } from 'react-router-dom'
import { HtmlEditor, Image, Inject, Link, QuickToolbar, RichTextEditorComponent, Toolbar } from '@syncfusion/ej2-react-richtexteditor';

const levelOptions = [
    { value: 'beginner', label: 'Beginner' },
    { value: 'intermidiate', label: 'Intermidiate' }
];

const languageOptions = [
    { value: 'English', label: 'English' },
    { value: 'Amharic', label: 'Amharic' }
];

export default function AddCourse() {
     const [uploading, setUploading] = useState(false)
     const [sources, setSources] = useState()
     const [files, setFiles] = useState([])
     const [categories, setCategories] = useState([])
     const [instructors, setInstructors] = useState([])
     const [selectedCategory, setSelectedCategory] = useState(null)
     const {courseId} = useParams()
     const [course, setCourse] = useState({})
     const [isDeleting, setIsDeleting]= useState(false)
     const [description, setDescription] = useState(null)
     const onChangeDescription = (value) => setDescription(value)
     let rteObj

     const fileRef = useRef()
     const {setNotification} = useContext(appContext)
     const { register, handleSubmit, trigger, setValue, watch, control, formState: { errors, isSubmitting, isDirty, isValid } } = useForm();
     console.log(errors, isValid, isDirty   )
     const categoryValue = watch('category')
     const priceValue = watch('price')
     const navigate = useNavigate()
     const [isFree, setIsFree] = useState(false)
     const valueRef = useRef()

     const uploadImage = (event) => {
        setFiles([event.target.files[0]])
     }

     const deleteCourse = () => {
         let confirm = window.confirm('Are you sure you want to delete this course?')
         if(confirm){
             setIsDeleting(true)
             api.delete(path.course, {
                 data: {
                     courseId
                 }
             }).then(response => {
                 let data = response.data
                 if(data.success){
                    setNotification({
                        message: `Course successfully Deleted!`,
                        visible: true,
                        type: 'success'
                    })
                    navigate(-1)
                 }
             }).finally(() => setIsDeleting(false))
         }
     }

     useEffect(() => {
         if(courseId){
             api.get(path.getCourse + '/' + courseId).then(response => {
                 let data = response.data
                 if(data.success){
                     setCourse(data.course)
                     setValue('title', data.course.title)
                     setValue('level', {value: data.course.level, label: data.course.level})
                     setValue('languages', {value: data.course.languages, label: data.course.languages})
                     setValue('description', data.course.description)
                     setValue('price', (parseFloat(data.course.price) / 1.1).toFixed(0))
                     setDescription(data.course.description)
                     setIsFree(data.course.isFree)
                     trigger()
                    //  setValue('level', data.course.level)
                 }
             })
         }
     }, [trigger])

     useEffect(() => {
        axios(baseUrl + path.fetchCategories).then(response => {
            setCategories(response.data.categories)
        })
     }, [])

     useEffect(() => {
        if(categories){
            setSelectedCategory(categories.find(cat => cat.name == categoryValue?.label))
            setValue('subCategory', null)
        }
     }, [categoryValue, categories])

     const getValue = () => {
         if(rteObj) return rteObj.value
     }

     const submit = (data) => {
         console.log(valueRef.current)
        return new Promise((resolve, reject) => {
            api(courseId ? path.course : path.addCourse, {
                method: courseId ? 'patch' : 'post',
                data: {
                    ...data,
                    subcategoryId: data.subCategory?.value,
                    languages: data.languages?.value,
                    level: data.level.value,
                    thumbnail: sources,
                    courseId,
                    isFree,
                    description: valueRef?.current
                }
            }).then(response => {
                resolve(true)
                if(response.data.success){
                    setNotification({
                        message: `Course successfully ${courseId ? 'updated' : 'created'}!`,
                        visible: true,
                        type: 'success'
                    })
                    navigate(-1)
                } else {
                    setNotification({
                        message: response.data.message,
                        visible: true,
                        type: 'error'
                    })
                }
            }).catch(e => {
                console.log(e)
                resolve(true)
                setNotification({
                    message: 'Unkown error occured!',
                    visible: true,
                    type: 'error'
                })
            })
        })
     }

    return (
    <div className='flex flex-col gap-5 h-full w-full bg-white rounded-sm p-4 overflow-auto'>
        <h2 className='text-black opacity-75 text-[18px] font-bold'>
            {courseId ? 'Edit Course' : 'Create Course (In the next steps you will create sections and subsections.)' }</h2>
        <div className='flex flex-col gap-3 max-md:items-center'>
            <form onSubmit={handleSubmit(submit)} className='flex flex-col gap-3 w-fit'>
                <div className='grid grid-cols-2 w-fit gap-x-5 gap-y-5 max-md:flex flex-col max-md:gap-2'>
                    <input {...register('title', {required: true})} placeholder='Course Title' type='text' className='border-[1px] border-solid border-[#00000090] text-black placeholder:text-[#434343] p-2 w-full' />
                    {/* {register({ name: 'category' }, {required: true})} */}
                    {!courseId && <Controller
                        name="category"
                        control={control}
                        rules={{ required: true }}
                        render={({ field }) => (
                            <Select
                                {...field}
                                // onChange={(data) => setSelectedCategory(categories.find(cat => cat.name == data.label))}
                                className='text-black placeholder:text-[#434343] w-full z-[9999]'
                                defaultValue={''}
                                placeholder='Course Category'
                                options={categories.map(cat => ({label: cat.name, value: cat.id}))}
                            />
                        )}
                    /> }
                    
                    {/* {register({ name: 'subcategory' }, {required: true})} */}
                    {!courseId && <Controller
                        name="subCategory"
                        control={control}
                        rules={{ required: true }}
                        render={({ field }) => (
                            <Select
                                {...field}
                                className='text-black placeholder:text-[#434343] w-full'
                                defaultValue={''}
                                placeholder={selectedCategory ? 'Course Sub-Category' : 'Please first select main category'}
                                options={selectedCategory?.subcategories?.map(cat => ({label: cat.name, value: cat.id})) || []}
                            />
                        )}
                    /> }
                    {/* <Controller
                        name="instructor"
                        control={control}
                        rules={{ required: true }}
                        render={({ field }) => (
                            <Select
                                {...field}
                                className='text-black placeholder:text-[#434343] w-full'
                                defaultValue={''}
                                placeholder='Course Instructor'
                                options={instructors.map(ins => ({label: ins?.user?.firstName + ' ' + ins?.user?.lastName, value: ins.id}))}
                            />
                        )}
                    /> */}
                    {/* {register({ name: 'level' }, {required: true})} */}
                    <Controller
                        name="level"
                        control={control}
                        rules={{ required: true }}
                        render={({ field }) => (
                            <Select
                                {...field}
                                className='text-black placeholder:text-[#434343] w-full z-[9999]'
                                defaultValue={''}
                                placeholder='Course Level'
                                options={levelOptions}
                            />
                        )}
                    />
                    
                    <Controller
                        name="languages"
                        control={control}
                        rules={{ required: true }}
                        render={({ field }) => (
                            <Select
                                {...field}
                                className='text-black placeholder:text-[#434343] w-full'
                                placeholder='Language'
                                options={languageOptions}
                            />
                        )}
                    />
                    <div className='flex items-center gap-3'>
                        <input id="free" checked={isFree} onChange={e => setIsFree(e.target.checked)} type='checkbox' />
                        <label for="free" className='text-[14px] font-bold'>Is Free Course</label>
                    </div>
                    <div className='flex flex-col gap-2'>
                        <input disabled={isFree} autocomplete="off" {...register('price', {required: false})} placeholder='Price (ETB)' type='number' className='h-fit border-[1px] border-solid border-[#00000090] text-black placeholder:text-[#434343] p-2 w-full' style={{opacity: isFree ? '0.5' : '1'}} />
                        <p>+10% (Display Price <span className='font-bold text-[#ff0000]'>{(parseFloat(priceValue || 0) * 1.1).toFixed(0)} ETB</span>) </p>
                    </div>
                    {/* <textarea {...register('description', {required: true})} placeholder='Course Description (Briefly describe what will students get up-on completion)' cols={3} rows={3} type='text' className='border-[1px] border-solid border-[#00000090] text-black placeholder:text-[#434343] p-2 w-full' /> */}
                    <RichTextEditorComponent ref={(richtexteditor) => { rteObj = richtexteditor; }} value={description}>
                        
                        <Inject services={[Toolbar, Image, Link, HtmlEditor, QuickToolbar]} />
                    </RichTextEditorComponent>
                    <div className='flex flex-col gap-2'>
                        <p className='text-[14px] text-black'>Thumbnail (16:9 Aspect ratio)</p>
                        <div className='flex gap-2 items-center'>
                            <input ref={fileRef} onChange={uploadImage} type='file' className='border-solid border-[1px] max-md:w-[200px] border-[#00000040] p-2' />
                            <button type='button' onClick={() => fileRef.current?.click()} className={`bg-black p-2 text-[12px] text-white`}>Change</button>
                        </div>
                        <div className='flex flex-wrap gap-2'>
                            {files.map(file => (
                                <UploadItem file={file} setUploading={setUploading} setSources={setSources} />
                            ))}
                        </div>
                    </div>
                    <div></div>
                    {/* <div className='flex w-full gap-3 items-center'>
                        <div className='flex items-center gap-1'>
                            <input {...register('hasCertificate')} type='checkbox' />
                            <p className='text-[12px]'>Has Certificate</p>
                        </div>
                        <div className='flex items-center gap-1'>
                            <input {...register('hasLiveSession')} type='checkbox' />
                            <p className='text-[12px]'>Has Live Session</p>
                        </div>
                        <div className='flex items-center gap-1'>
                            <input {...register('hasInPerson')} type='checkbox' />
                            <p className='text-[12px]'>Has In Person Mettings</p>
                        </div>
                    </div> */}

                    <div>
                    
                    <button onClick={() => {
                        valueRef.current = getValue()
                    }} disabled={isSubmitting || !isValid || (!sources && !courseId)} type='submit' className={`${!isValid || (!sources && !courseId) ? 'bg-[#a3a3a3]' : 'bg-main'} text-white text-[14px] w-full p-3 flex items-center justify-center h-fit`}>
                        {isSubmitting ? (
                            <Oval
                                visible={true}
                                height="21"
                                width="21"
                                color="#198754"
                                ariaLabel="oval-loading"
                                wrapperStyle={{}}
                                wrapperClass=""
                                strokeWidth={3}
                            />
                        ) : 'Save'}
                    </button>
                    {courseId && <button disabled={isDeleting} type='button' onClick={deleteCourse} className={`mt-4 bg-[#ff0000] text-white text-[14px] w-full p-3 flex items-center justify-center h-fit`}>
                        {isDeleting ? (
                            <Oval
                                visible={true}
                                height="21"
                                width="21"
                                color="#198754"
                                ariaLabel="oval-loading"
                                wrapperStyle={{}}
                                wrapperClass=""
                                strokeWidth={3}
                            />
                        ) : 'Delete Course'}
                    </button> }
                    </div>
                </div>
                
                
            </form>
        </div>
    </div>
    )
}

export function UploadItem({ file, setUploading, setSources }){
    const [loading, setLoading] = useState(true)
    const [source, setSource] = useState(null)

    useEffect(() => {
        setLoading(true)
        let form  = new FormData()
        form.append('file', file)
        console.log(file)
        axios(baseUrl + path.uploadFile + '?to=images', {
            data: form,
            method: 'post',
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }).then(response => {
            if(response.data.success){
                setLoading(false)
                setSource(response.data.source)
                setSources(response.data.source)
            }
        })
    }, [file])

    return (
        <div className='w-[70px] h-[70px] border-[#00000050] border-solid border-[1px] p-1 flex items-center justify-center'>
            {loading ? (
                <Oval
                    visible={true}
                    height="24"
                    width="25"
                    color="#198754"
                    ariaLabel="oval-loading"
                    wrapperStyle={{}}
                    wrapperClass=""
                    strokeWidth={3}
                /> ): (
                    <img src={baseUrl + source} alt='source' className='w-full h-full object-contain'  />
                )}
        </div>
    )
}